import React from 'react';
import styles from '../capitalExpenditure.module.scss';

const CapitalExpenditureHeader = ({
  activeTab,
  setActiveTab,
  selectedOffice,
  viewMode,
  lockSelection = false,
  showOfficeDropdown,
  officeSearchTerm,
  officeOptions,
  lastSavedToken,
  message,
  messageType,
  handleOfficeDropdownToggle,
  handleOfficeSelect,
  setOfficeSearchTerm,
  selectedFiscalYear,
  setSelectedFiscalYear,
  fiscalYears,
  onTabChange,
  onRefreshClick,
  onLogout,
  isAuthenticated
}) => {
  const isSelectionLocked = viewMode || lockSelection;
  
  return (
    <>
      {/* Header */}
      <div className={styles.header}>
        <h1 className={styles.universityTitle}>मध्यपश्चिम विश्वबिधालय</h1>
        <div className={styles.currentYearBanner} title="चालु आर्थिक वर्ष">
          <span className={styles.currentYearLabel}>आर्थिक वर्ष</span>
          <strong className={styles.currentYearValue}>
            {selectedFiscalYear?.name || '—'}
          </strong>
        </div>
        
                 {/* Tab Navigation */}
         <div className={styles.navButtons}>
           <button 
             className={`${styles.navButton} ${activeTab === 'newData' ? styles.activeTab : ''}`}
             onClick={() => {
               onTabChange && onTabChange('newData');
               setActiveTab('newData');
             }}
           >
             नयाँ डाटा थप्नुहोस्
           </button>

           <button
             className={`${styles.navButton} ${activeTab === 'budget' ? styles.activeTab : ''}`}
             onClick={() => {
               onTabChange && onTabChange('budget');
               setActiveTab('budget');
             }}
           >
             बजेट
           </button>
           
           {/* Protected tabs - only show when authenticated */}
           {isAuthenticated && (
             <>
               <button 
                 className={`${styles.navButton} ${activeTab === 'dataView' ? styles.activeTab : ''}`}
                 onClick={() => {
                   onTabChange && onTabChange('dataView');
                   setActiveTab('dataView');
                 }}
               >
                 डाटा हेर्नुहोस्
               </button>
               <button 
                 className={`${styles.navButton} ${activeTab === 'institutionManager' ? styles.activeTab : ''}`}
                 onClick={() => {
                   onTabChange && onTabChange('institutionManager');
                   setActiveTab('institutionManager');
                 }}
               >
                 संस्था थप्नुहोस्
               </button>
               <button 
                 className={`${styles.navButton} ${activeTab === 'settings' ? styles.activeTab : ''}`}
                 onClick={() => {
                   onTabChange && onTabChange('settings');
                   setActiveTab('settings');
                 }}
               >
                 सेटिङहरू
               </button>
             </>
           )}
           
           {onLogout && isAuthenticated && (
             <button 
               className={`${styles.navButton} ${styles.logoutButton}`}
               onClick={onLogout}
               title="लगआउट गर्नुहोस्"
             >
               लगआउट
             </button>
           )}
           
           {/* Token Search tab - show before login */}
           {!isAuthenticated && (
             <button 
               className={styles.navButton}
               onClick={() => window.open('/token-search', '_blank')}
               title="टोकनबाट डाटा खोज्नुहोस् (नयाँ ट्याबमा खुल्छ)"
             >
               🔍 टोकन खोज
             </button>
           )}
           
           {/* Login button - only show when not authenticated */}
           {!isAuthenticated && (
             <button 
               className={`${styles.navButton} ${styles.loginButton}`}
               onClick={() => window.location.href = '/login'}
               title="लगइन गर्नुहोस्"
             >
               लगइन
             </button>
           )}
         </div>
        
        {/* Office Selection - Hide on Data View tab */}
        {activeTab !== 'dataView' && (
          <div className={styles.officeDropdownContainer}>
            <div 
              className={`${styles.officeDropdown} ${!selectedOffice.id ? styles.required : ''} ${isSelectionLocked ? styles.disabled : ''}`}
              onClick={isSelectionLocked ? undefined : handleOfficeDropdownToggle}
            >
              <span className={styles.selectedOffice}>
                {selectedOffice.name || 'कार्यालय खोज्नुहोस्...'}
              </span>
              <span className={styles.dropdownArrow}>▼</span>
            </div>
            
                         {/* Refresh Button - Only show on newData tab */}
             {activeTab === 'newData' && (
               <button
                 onClick={onRefreshClick}
                 className={styles.refreshButton}
                 title="पृष्ठ रिफ्रेश गर्नुहोस्"
               >
                 🔄 रिफ्रेश
               </button>
             )}
            
            {showOfficeDropdown && !isSelectionLocked && (
              <div className={styles.officeDropdownMenu}>
                <div className={styles.searchContainer}>
                  <input
                    type="text"
                    placeholder="कार्यालय खोज्नुहोस्..."
                    value={officeSearchTerm}
                    onChange={(e) => setOfficeSearchTerm(e.target.value)}
                    className={styles.officeSearchInput}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
                <div className={styles.officeOptionsList}>
                  {officeOptions
                    .filter(office => office.name.toLowerCase().includes(officeSearchTerm.toLowerCase()))
                    .map((office, index) => (
                      <div
                        key={index}
                        className={`${styles.officeOption} ${selectedOffice.id === office.id ? styles.selected : ''}`}
                        onClick={() => handleOfficeSelect(office)}
                      >
                        <div className={styles.officeName}>{office.name}</div>
                        <div className={styles.officeCategory}>{office.category_name}</div>
                      </div>
                    ))}
                </div>
              </div>
            )}


          </div>
        )}

        {/* Fiscal Year — users see the locked current year; admin can switch previous years */}
        <div className={styles.fiscalYearContainer}>
          {isAuthenticated ? (
            <select
              className={`${styles.fiscalYearSelect} ${isSelectionLocked ? styles.disabled : ''}`}
              value={selectedFiscalYear?.id || ''}
              onChange={isSelectionLocked ? undefined : (e) => {
                const fiscalYear = fiscalYears.find(fy => fy.id === parseInt(e.target.value, 10));
                setSelectedFiscalYear(fiscalYear || null);
              }}
              disabled={isSelectionLocked}
              title="एड्मिनले अघिल्लो वर्ष हेर्न सक्नुहुन्छ। नयाँ डाटाको डिफल्ट चालु वर्ष हो।"
            >
              {fiscalYears.map(fiscalYear => (
                <option key={fiscalYear.id} value={fiscalYear.id}>
                  {fiscalYear.name}{fiscalYear.is_current ? ' (चालु)' : ''}
                </option>
              ))}
            </select>
          ) : (
            <div className={styles.fiscalYearLocked} aria-readonly="true">
              {selectedFiscalYear?.name || 'आर्थिक वर्ष लोड हुँदैछ...'}
            </div>
          )}
        </div>
      </div>

      {/* Messages */}
      {message && (
        <div className={`${styles.message} ${styles[messageType]}`}>
          {message}
        </div>
      )}

      {/* Last Saved Token */}
      {lastSavedToken && (
        <div className={styles.tokenDisplay}>
          <div className={styles.tokenInfo}>
            <h4>अन्तिम सेभ गरिएको डाटा</h4>
            <div className={styles.tokenDetails}>
              <span><strong>टोकन:</strong> {lastSavedToken.token}</span>
              <span><strong>संस्था:</strong> {lastSavedToken.institution}</span>
              <span><strong>समय:</strong> {lastSavedToken.createdAt}</span>
            </div>
            <p className={styles.tokenNote}>
              यो टोकन प्रयोग गरेर तपाईंले आफ्नो डाटा सम्पादन गर्न सक्नुहुन्छ
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default CapitalExpenditureHeader;
